import type { TrackDef } from '../track';
import { autoGates } from './util';

/**
 * Rio Bay Circuit: tribute to round 6, the finale, Rio de Janeiro
 * (design.md A5.6). The longest lap: a long start straight, up the right,
 * two tight loops and a twisty infield. Driven anticlockwise.
 */
const centerline: [number, number][] = [
  [8, 37], [64, 37], [68, 35], [68.5, 23], [66, 20], [61, 16.5], [57.5, 13.5], [57, 6],
  [54, 3], [49.5, 1], [46, 3], [44.5, 6], [44.5, 17], [47, 19.5], [52, 21.5], [58, 23],
  [62.5, 25], [62.5, 28], [59, 30], [52, 30.5], [28, 30.5], [25.5, 28], [25.5, 25], [28, 21],
  [31, 17], [34, 14], [35.5, 11], [34.5, 8.5], [31, 6.5], [28, 7.5], [26, 9.5], [23, 12],
  [20, 15], [18.5, 18], [18.5, 28], [16.5, 30.5], [7, 31], [4, 32.5], [3.5, 35],
];

export const RIO_BAY: TrackDef = {
  id: 'rio-bay',
  name: 'RIO BAY CIRCUIT',
  subtitle: 'Tribute to Rio de Janeiro',
  country: 'BRAZIL',
  theme: 'tropical',
  scale: 48.9,
  offset: [5, 5],
  centerline,
  roadWidth: 72,
  kerbWidth: 6,
  runoffWidth: 20,
  runoffSurface: 'grass',
  gates: autoGates(centerline, 0, 0.35, 7),
  carparks: [],
  raceLaps: 2,
  defaultRecord: 47,
};
